import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsTHandlingLogEntryForwardCancelEvent } from "../../../common/types/order-details-handling-log-entry-event";

const getHeadingText = (
  producerDisplayName: OrderDetailsTHandlingLogEntryForwardCancelEvent["producerDisplayName"],
  consumerDisplayName: OrderDetailsTHandlingLogEntryForwardCancelEvent["consumerDisplayName"],
) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .forwardCancelOrderEntry.headingText;

  return translations
    .replace("#{producerDisplayName}", producerDisplayName ?? "-----")
    .replace("#{consumerDisplayName}", consumerDisplayName ?? "-----");
};

const orderDetailsHistoryEntryForwardCancelContentHelper = { getHeadingText };

export default orderDetailsHistoryEntryForwardCancelContentHelper;
